import { Box } from "@mui/material";
import React, {
	Dispatch,
	SetStateAction,
	Suspense,
	memo,
	useEffect,
	useState,
} from "react";
import { Col, Row } from "rsuite";
import ScatterGraph from "../../../components/scatter-graph";
import {
	getCPCustomerList,
	getCPDetailForCustomer,
} from "../../../queries/ScenarioForecast";
import CustomerSelectedMetrices from "./CustomerSelectedMetrices";
import CustomerSelectedOpportunities from "./CustomerSelectedOpportunities";
import useFilter from "../../../hooks/useFilter";

type Props = SummaryAndDetialFilterSelectedValues &
	BaseCustomerPortabilityFilterValues & {
		setLoading: Dispatch<SetStateAction<number>>;
		handleCustomerChange: (customer: string) => void;
		isFilterExpanded: boolean
	};

const Details = ({
	customer,
	date,
	district,
	project,
	setLoading,
	handleCustomerChange,
	isFilterExpanded,
	...rest
}: Props) => {
	console.log(rest)
	const [scatterGraphData, setCatterGraphData] = useState<Customer[]>([]);

	const [selectedCustomerId, setSelectedCustomerId] = useState<string>("");
	const [detailedData, setDetailedData] = useState<CustomerDetails>();
	const [averageLine, setAverageLine] = useState<AverageLine>();

	const { selectedFilter } = useFilter()
	useEffect(() => {
		fetchCustomerList();
	}, [date, district, project]);

	useEffect(() => {
		if (customer) {
			setSelectedCustomerId(customer);
			fetchDetailedData({ id: customer });
		}
	}, [customer, date, district, project]);

	const fetchCustomerList = async () => {
		setLoading((prev) => prev + 1);
		try {
			const res = await getCPCustomerList({
				District: district || "",
				dateRange: date || "",
				projectFlag: project || "All",
			}, selectedFilter);
			setCatterGraphData(res?.data?.data);
			setAverageLine(res?.data?.avgLineData?.[0]);
		} catch (err) {
			console.log("error in get APi --", err);
		} finally {
			setLoading((prev) => prev - 1);
		}
	};

	const fetchDetailedData = async (value: any) => {
		setLoading((prev) => prev + 1);
		try {
			const response = await getCPDetailForCustomer({
				customerId: value.id,
				District: district || "",
				dateRange: date || "",
				projectFlag: project || "",
			});
			setDetailedData(response?.data?.data);
		} catch (err) {
			console.log("Error while fetching detailed data: " + err);
		} finally {
			setLoading((prev) => prev - 1);
		}
	};

	const handleScatterGraphClick = async (value: any) => {
		if (value?.id === selectedCustomerId) {
			setDetailedData(undefined);
			setSelectedCustomerId("");
			handleCustomerChange("");
		} else {
			setSelectedCustomerId(value.id);
			handleCustomerChange(value.id);
		}
	};

	return (
		<Row className={`show-grid flex py-[0.5%]  w-full ml-[0.5px]`}>
			<Col xs={24} sm={24} md={8}>
				<Box className="chart-title text-center pb-[5px] w-full text-black font-bold">
					Gross Margin vs Contribution Margin by Customers
				</Box>
				<Box
					className={`border border-lightGrey p-[6px] bg-white  shadow-md ${isFilterExpanded ? "h-[54.2vh]" : "h-[62.2vh]"}`}
					id="graph"
				>
					<ScatterGraph
						selectedCustomerId={selectedCustomerId || ""}
						data={scatterGraphData}
						handleSummaryTabScatterGrphCall={
							handleScatterGraphClick
						}
						refX={
							(averageLine?.avg_deliveredMargin || 0) *
							100
						}
						refY={(averageLine?.avg_grossMargin || 0) * 100}
					/>
				</Box>
			</Col>

			<Col className="h-full !w-[1%]"></Col>
			{!detailedData ? (
				<Col xs={24} sm={24} md={16} className="h-full">
					<div className="flex justify-center items-center basis-[60vw]">
						<span className="text-[2.5vh] font-normal italic text-[#000]">
							Click on the left chart to get the details
						</span>
					</div>
				</Col>
			) : (
				<Col xs={24} sm={24} md={16} className="flex flex-col justify-between">
					<Box>
						<CustomerSelectedMetrices
							isFilterExpanded={isFilterExpanded}
							detailedData={detailedData}
						/>
					</Box>
					<Box>
						<CustomerSelectedOpportunities
							detailedData={detailedData}
							selectedDistrict={district}
							selectedScatterData={scatterGraphData}
							selectedCustomerId={customer}
							isFilterExpanded={isFilterExpanded}
						/>
					</Box>
				</Col>
			)}
		</Row>
	);
};

export default memo(Details);
